import React, { useEffect, useState } from "react";
import { Wordmark } from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Legacy", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Mivan", href: "#mivan" },
  { label: "Projects", href: "#projects" },
  { label: "Trust", href: "#legacy" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink-900/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center">
          <Wordmark small />
        </a>

        <nav className="hidden lg:flex items-center gap-10" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[12px] uppercase tracking-[0.22em] font-medium text-steel-light hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="navbar-cta"
          className="hidden lg:inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] font-semibold text-ink-900 bg-gold hover:bg-gold-light px-5 py-3 transition-colors duration-300"
        >
          Request a Consultation
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="navbar-menu-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ink-900/95 backdrop-blur-xl border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="text-sm uppercase tracking-[0.22em] text-steel-light hover:text-gold"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-navbar-cta"
              className="mt-2 inline-flex items-center justify-center text-xs uppercase tracking-[0.22em] font-semibold text-ink-900 bg-gold px-5 py-3"
            >
              Request a Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
